exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-popover.tag_popover{padding:0;background-color:#d0efff;background:-webkit-gradient(linear,left top,left bottom,from(#02457a),to(#1167b1));background:linear-gradient(#02457a,#1167b1);border:none;min-width:20px}.el-popover.tag_popover[x-placement^=top] .popper__arrow,.el-popover.tag_popover[x-placement^=top] .popper__arrow:after{border-top-color:#1167b1}", ""]);

// exports
